import { E } from "@scripts/fp-ts";
import * as p from "@scripts/generated/domaintables/pages";
import { SitesJumpLink } from "@scripts/react/components/SidebarLinks";

import * as bonds from "./bondsJumpLinks";

export const archivedBondSales = SitesJumpLink("Archived Bond Sales", [E.right(p.bondArchive)]);

export const allStatic: ReadonlyArray<SitesJumpLink> = [archivedBondSales, bonds.generalOfferingInfo];
